import { locationsManagementApi, rolesApi } from '@/api';
import { laboratories } from '@/config/constants';

const availableLaboratories = [
  { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
  { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
];

const usersFilters = [
  {
    name: 'name',
    label: 'role',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const response = await rolesApi.autocompleteFetch(queryString);
      const roles = response.data.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      cb(roles);
    },
  },
  {
    name: 'laboratory',
    label: 'laboratory',
    type: 'select',
    whereOperator: '=',
    options: availableLaboratories,
  },
  {
    name: 'locationId',
    label: 'location',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'isEnabled',
    label: 'activeInactive',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'filters.active', value: 1 },
      { label: 'filters.inactive', value: 0 },
    ],
  },
];

export default usersFilters;
